// extracted by mini-css-extract-plugin
export var container = "SystemIntegrations-module--container--4a59a";
export var image = "SystemIntegrations-module--image--02750";
export var item = "SystemIntegrations-module--item--de119";
export var typography = "SystemIntegrations-module--typography--f8227";